import PageAboutPurchase from '~/themes/base/components/content/PageAboutPurchase'

export default {
  extends: PageAboutPurchase,
}
